import React, { useState } from "react";
import Loader from "../../../components/Loader/Loader";
import Card from "./components/Card";
import { MdImage, MdPendingActions } from "react-icons/md";
import { FaFirstOrderAlt } from "react-icons/fa6";
import { FaUsers } from "react-icons/fa";
import { RiPassPendingLine } from "react-icons/ri";
import PendingOrders from "./components/PendingOrders";
import BestProducts from "./components/BestProducts";

const Dashboard = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const columns = [
    "# ID",
    "User",
    "Date",
    "Items",
    "Payment Method",
    "Total Price",
    "Status",
    "",
  ];
  const productColums = [
    "# ID",
    "Image",
    "Title",
    "Description",
    "price",
  ];
  const orderData = [
    {
      id: 48,
      total: "59.00",
      createdDate: "2024-04-07T13:54:02.330Z",
      delivered: 0,
      paymentMethod: "Cash",
      products:
        '[{"id":8,"title":"iPhone 15 Pro Clear Case with MagSafe","description":"Thin, light, and easy to grip — this Apple-designed case shows off the brilliant colored finish of iPhone 15 Pro while providing extra protection. Crafted with a blend of optically clear polycarbonate and flexible materials, the case fits right over the buttons for easy use. On the surface, a scratch-resistant coating has been applied to both the interior and exterior. And all materials and coatings are optimized to prevent yellowing over time.","image_url":"https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/MT223?wid=1144&hei=1144&fmt=jpeg&qlt=90&.v=1693248280978","price":"49","quantity":1,"totalProductPrice":49}]',
      status: "Pending",
      userId: 48,
      address:
        '{"id":21,"address":"House No # 55 Street No # 5 G-5, Islamabad, Pakistan","label":"Test","lat":"33.7218048","lng":"73.0980773","userId":"48"}',
      attachedImageUrl: "",
      card: null,
      name: "Usman",
      email: "iusmansultan@gmail.com",
      password: "$2b$10$ROA40j8mAqNk0n5jQ9buq.1udXxmHTIZedE8G2vJYIm.uhyx/HchO",
      phone: "+923408558878",
      isActive: "1",
      imageUrl:
        "https://firebasestorage.googleapis.com:443/v0/b/free-togo-mobile-app.appspot.com/o/UserProfiles%2FUsman48?alt=media&token=0ec799a7-41dc-4760-87ad-165de212d8fe",
      stripeCustomerId: "cus_PkDHTthO29dbio",
      Oid: 81,
    },
    {
      id: 50,
      total: "390.40",
      createdDate: "2024-04-01T18:16:02.673Z",
      delivered: 0,
      paymentMethod: "COD",
      products:
        '[{"description":"Thin, light, and easy to grip — this Apple-designed case shows off the brilliant colored finish of iPhone 15 Pro while providing extra protection. Crafted with a blend of optically clear polycarbonate and flexible materials, the case fits right over the buttons for easy use. On the surface, a scratch-resistant coating has been applied to both the interior and exterior. And all materials and coatings are optimized to prevent yellowing over time.","id":8,"image_url":"https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/MT223?wid=1144&hei=1144&fmt=jpeg&qlt=90&.v=1693248280978","price":"49","quantity":1,"title":"iPhone 15 Pro Clear Case with MagSafe","totalProductPrice":49}]',
      status: "Pending",
      userId: 48,
      address:
        '{"address":"Street 5 - Dubai - United Arab Emirates","label":"Office","lat":"25.0422225","lng":"55.1410445"}',
      attachedImageUrl: "afafafdfafdfdsfsadfa",
      card: null,
      name: "Usman",
      email: "iusmansultan@gmail.com",
      password: "$2b$10$ROA40j8mAqNk0n5jQ9buq.1udXxmHTIZedE8G2vJYIm.uhyx/HchO",
      phone: "+923408558878",
      isActive: "1",
      imageUrl:
        "https://firebasestorage.googleapis.com:443/v0/b/free-togo-mobile-app.appspot.com/o/UserProfiles%2FUsman48?alt=media&token=0ec799a7-41dc-4760-87ad-165de212d8fe",
      stripeCustomerId: "cus_PkDHTthO29dbio",
      Oid: 80,
    },
    {
      id: 52,
      total: "390.40",
      createdDate: "2024-04-01T18:16:02.673Z",
      delivered: 0,
      paymentMethod: "COD",
      products:
        '[{"description":"Thin, light, and easy to grip — this Apple-designed case shows off the brilliant colored finish of iPhone 15 Pro while providing extra protection. Crafted with a blend of optically clear polycarbonate and flexible materials, the case fits right over the buttons for easy use. On the surface, a scratch-resistant coating has been applied to both the interior and exterior. And all materials and coatings are optimized to prevent yellowing over time.","id":8,"image_url":"https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/MT223?wid=1144&hei=1144&fmt=jpeg&qlt=90&.v=1693248280978","price":"49","quantity":1,"title":"iPhone 15 Pro Clear Case with MagSafe","totalProductPrice":49}]',
      status: "Pending",
      userId: 48,
      address:
        '{"address":"Street 5 - Dubai - United Arab Emirates","label":"Office","lat":"25.0422225","lng":"55.1410445"}',
      attachedImageUrl: "afafafdfafdfdsfsadfa",
      card: null,
      name: "Usman",
      email: "iusmansultan@gmail.com",
      password: "$2b$10$ROA40j8mAqNk0n5jQ9buq.1udXxmHTIZedE8G2vJYIm.uhyx/HchO",
      phone: "+923408558878",
      isActive: "1",
      imageUrl:
        "https://firebasestorage.googleapis.com:443/v0/b/free-togo-mobile-app.appspot.com/o/UserProfiles%2FUsman48?alt=media&token=0ec799a7-41dc-4760-87ad-165de212d8fe",
      stripeCustomerId: "cus_PkDHTthO29dbio",
      Oid: 51,
    },
    {
      id: 52,
      total: "390.40",
      createdDate: "2024-04-01T18:16:02.673Z",
      delivered: 0,
      paymentMethod: "COD",
      products:
        '[{"description":"Thin, light, and easy to grip — this Apple-designed case shows off the brilliant colored finish of iPhone 15 Pro while providing extra protection. Crafted with a blend of optically clear polycarbonate and flexible materials, the case fits right over the buttons for easy use. On the surface, a scratch-resistant coating has been applied to both the interior and exterior. And all materials and coatings are optimized to prevent yellowing over time.","id":8,"image_url":"https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/MT223?wid=1144&hei=1144&fmt=jpeg&qlt=90&.v=1693248280978","price":"49","quantity":1,"title":"iPhone 15 Pro Clear Case with MagSafe","totalProductPrice":49}]',
      status: "Pending",
      userId: 48,
      address:
        '{"address":"Street 5 - Dubai - United Arab Emirates","label":"Office","lat":"25.0422225","lng":"55.1410445"}',
      attachedImageUrl: "afafafdfafdfdsfsadfa",
      card: null,
      name: "Usman",
      email: "iusmansultan@gmail.com",
      password: "$2b$10$ROA40j8mAqNk0n5jQ9buq.1udXxmHTIZedE8G2vJYIm.uhyx/HchO",
      phone: "+923408558878",
      isActive: "1",
      imageUrl:
        "https://firebasestorage.googleapis.com:443/v0/b/free-togo-mobile-app.appspot.com/o/UserProfiles%2FUsman48?alt=media&token=0ec799a7-41dc-4760-87ad-165de212d8fe",
      stripeCustomerId: "cus_PkDHTthO29dbio",
      Oid: 52,
    },
  ];

  const bestProducts = [
        {
            "id": 14,
            "title": "2 Socketed EV Home Charger",
            "description": "Colour: Black, Type 2 socket, 3-year homeowner warranty 187 x 122 x 90mm (H x W x D)",
            "image_url": "https://freetogo.uk/wp-content/uploads/2023/08/p9-100x100.png",
            "price": "349"
        },
        {
            "id": 15,
            "title": "58 Piece Computer Repair Tool Kit",
            "description": "Sprotek STK-8918 Tool Set (58 Tools)",
            "image_url": "https://freetogo.uk/wp-content/uploads/2024/03/71msXPbfgSL.__AC_SX300_SY300_QL70_ML2_.jpg",
            "price": "27.18"
        },
        {
            "id": 16,
            "title": "5W-7W Fire Rated LED Downlight",
            "description": "Colour: White, Package Weight: 1.32 kilograms, Package Dimensions (L x B ) in cm: 14 x 14",
            "image_url": "https://freetogo.uk/wp-content/uploads/2023/08/p8.png",
            "price": "12"
    },
  ]

  return (
    <div className="bg-white h-full w-full rounded-lg p-2 overflow-scroll hide-scrollbar  ">
      {loading && (
        <div className="fixed w-screen h-screen bg-black bg-opacity-10 top-0 right-0 z-30 flex items-center justify-center">
          <Loader />
        </div>
      )}

      <div className="flex w-full justify-between h-12 items-center">
        <h3 className="text-xl font-semibold ">Dashboard</h3>
      </div>

      <div className="w-full grid grid-flow-col auto-cols-[minmax(0,_2fr)] gap-2">
        <Card label="Orders: 300" icon={<FaFirstOrderAlt />} />
        <Card label="Users: 22" icon={<FaUsers />} />
        <Card label="Pending: 12" icon={<MdPendingActions />} />
        <Card label="Active: 2" icon={<RiPassPendingLine />} />
      </div>

      <PendingOrders columns={columns} data={orderData} />
      <BestProducts columns={productColums} data={bestProducts} />
    </div>
  );
};

export default Dashboard;
